import { cleanupFilename } from '@/utils/file.utils'

const FilenameMixin = {
  filters: {
    fileName: value => cleanupFilename(value)
  }
}

export default FilenameMixin
